<template>
  <div>
    <v-tabs
      v-model="tab"
      dark
      class="rounded-lg"
      dense
      background-color="primary"
      active-class="tab-active"
      slider-color="#ffbc00"
    >
      <v-tab class="font-weight-black">Comunicado</v-tab>
      <v-tab class="font-weight-black">Efemérides</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" touchless>
      <v-tab-item>
        <configuracionComunicado class="mt-2"></configuracionComunicado>
      </v-tab-item>
      <v-tab-item>
        <configuracionEfemerides class="mt-2"></configuracionEfemerides>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";

import ConfiguracionComunicado from "@/views/Inicio/Configuracion/components/ConfiguracionComunicados.vue";
import ConfiguracionEfemerides from "@/views/Inicio/Configuracion/components/ConfiguracionEfemerides.vue";

export default {
  name: "configuracionInicio",

  components: {
    configuracionComunicado: ConfiguracionComunicado,
    configuracionEfemerides: ConfiguracionEfemerides,
  },

  data() {
    return {
      mensaje: { tipo: "S", mensaje: "hi", tiempo: null }, // mensaje de sistema
      tab: 0,
      datoLogin: sessionStorage, // sesion del sistema
      paramComponente: { id_modulo: 3, id_submodulo: 143 },
    };
  },

  mounted() {
    this.loadMain();
  },

  created() {
    this.actualizarParamentro();
  },

  computed: {
    // a computed getter
    ...mapGetters("login", ["componenteEvento"]),
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA //////////////////////
    // -- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),
    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    async loadMain() {},
  },
};
</script>
